/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface ICampusProfileScope extends ng.IScope {
        vm: CampusProfile;
    }

    interface ICampusProfile {
        templateUrl: string;
        institution: IInstitution;
        groupOpen: any;
        map: any;
        institutionId: number;
        crossRoadsOrganizationId: number;
        carouselCount: any;
        apiHost: string;
        isSaved: boolean;
        isRecruited: boolean;
    }


    class CampusProfile implements ICampusProfile {
        static controllerId: string = "campusProfile";
        static $inject: Array<string> = ["$location", "$anchorScroll", "$routeParams", "common", "Restangular", "$sce", "getRecruitedService", "saveSchoolService", "$uibModal", "$route"];
        private log;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        institutionId: number;
        templateUrl: string = "about";
        institution: IInstitution;
        gps: any;
        carouselCount: any;
        apiHost: string;
        map: any = { center: {}, zoom: 15, options: { streetViewControl: false, zoomControlOptions: { style: google.maps.ZoomControlStyle.SMALL } } };
        groupOpen: any = {
            about: true,
        }
        isSaved: boolean = false;
        isRecruited: boolean = false;
        crossRoadsOrganizationId: number;
        majors: any;
        gradMajors: any;
        undergradMajors: any;
        slides: Array<any> = [];
        campusTourVideo: Array<any>;
        videos: Array<any>;
        active: number;
        activeSlide: number;
        activeVideo: number;
        photoInstitutionId: any;
        bannerStyles: any;
        currentYear: number;
        campusTour: string = "";

        constructor(private $location: ng.ILocationService,
            private $anchorScroll: ng.IAnchorScrollService,
            private $routeParams,
            private common: ICommonFactory,
            private Restangular: Restangular.IService,
            private $sce,
            private getRecruitedService: IGetRecruitedService,
            private saveSchoolService: ISaveSchoolService,
            private $uibModal: angular.ui.bootstrap.IModalService,
            private $route: angular.route.IRouteService) {

            this.log = common.logger.getLogFn(CampusProfile.controllerId);
            this.logError = common.logger.getLogFn(CampusProfile.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(CampusProfile.controllerId, "success");
            this.photoInstitutionId = this.institutionId;
            this.currentYear = new Date().getFullYear();

            this.Restangular.one("users/error").get().then(result => {
                console.log(result);
            }, error => console.log(error));

            if (this.$routeParams.section) {
                this.templateUrl = this.$routeParams.section.replace(/-/g, "");
            }
            this.activate();

        }

        activate() {
            var promises = [this.getProfileData()];
            this.common.activateController(promises, CampusProfile.controllerId)
                .then(() => {
                    var config = new Config();
                    this.active = 0;
                    this.getCarouselCount();

                    this.apiHost = config.apiHost;
                    this.Restangular.one("institutions", this.institutionId.toString().split('/')[1]).one("photo").one("metadata").get()
                        .then((result) => {
                            this.slides = result;
                            this.activeSlide = 0;

                            this.slides.forEach((slide) => {
                                slide.src = this.apiHost + "/" + this.institutionId + "/" + slide.name + "/image";
                                slide.active = false;
                            });

                        }, (reason) => {
                            console.log(reason);
                        });

                    this.bannerStyles = {
                        admissions: this.getBannerBaseStyle("admissions"),
                        academics: this.getBannerBaseStyle("academics"),
                        costAndFinancialAid: this.getBannerBaseStyle("costandfinancialaid"),
                        studentLife: this.getBannerBaseStyle("studentlife"),
                        transferStudent: this.getBannerBaseStyle("transferstudent"),
                        internationalStudents: this.getBannerBaseStyle("internationalstudent"),
                        learningDisabilities: this.getBannerBaseStyle("learningdisabled")
                    }

                    var command;
                    if (command = sessionStorage.getItem("collegeProfile.command")) {
                        switch (command) {
                            case "save":
                                this.saveCollege();
                                break;
                            case "getrecruited":
                                this.getRecruited();
                                break;
                        }                        
                    }

                    this.log("Activated CampusProfile View");
                });
            

        }

        getBannerBaseStyle(section) {
            return {
                "height": "150px",
                "background": `linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${this.apiHost}/${this.institutionId}/${section}/image)`,
                "background-repeat": "no-repeat",
                "background-size": "cover",
                "background-position": "center"
            };
        }

        getProfileData() {

            var urlname = this.$routeParams.institutionName;

            return this.Restangular.one("institutions", urlname).one("campusprofile").get()
                .then((results) => {
                if (!results || !results.crossRoadsOrganizationId) {
                    this.$location.path("/");
                }
                else {
                    this.institution = results;
                    this.institutionId = this.institution.id;
                    this.institution.profile.costFinancialAid.availableLoanTypes = this.institution.profile.costFinancialAid.availableLoanTypes.sort();
                    this.institution.profile.costFinancialAid.paymentPlans = this.institution.profile.costFinancialAid.paymentPlans.sort();
                    this.gps = { latitude: this.institution.profile.latitude, longitude: this.institution.profile.longitude };
                    this.campusTourVideo = [];
                    
                    this.videos = _.filter(this.institution.profile.videos,(video) => {
                        return video.pageSection == "Videos"
                    });
                    console.log(this.videos);
                    this.activeVideo = 0;

                    //this.videos.forEach((video, i) => {
                    //    if (i == 0) {
                    //        video.active = true;
                    //    }
                    //    video.src = video.thumbnailURL;
                    //});

                    _.filter(this.institution.profile.videos,(video) => {
                        return video.pageSection == "CampusTour"
                    }).forEach((video) => {
                        this.campusTour = video.videoURL;
                        //this.campusTourVideo.push({
                        //    src: video.videoURL,
                        //    type: "video/mp4",
                        //    title: video.title,
                        //    description: video.description
                        //})
                    });

                    this.map.center = { latitude: this.institution.profile.latitude, longitude: this.institution.profile.longitude };
                    this.common.authentication.isLoggedIn().then(loggedIn => {
                        if (loggedIn) {
                            this.isCollegeSaved();
                            this.isProspectSubmitted();
                        }
                    }); 

                    this.majors = _.sortBy(this.institution.majorsWithNames, "programName");
                    this.undergradMajors = _.filter(this.majors, function (major) { return major.degreeType == "Certificate" || major.degreeType == "Diploma" || major.degreeType == "Associate" || major.degreeType == "Bachelor"; });
                    this.gradMajors = _.filter(this.majors, function (major) { return major.degreeType == "PostBachelor" || major.degreeType == "Master" || major.degreeType == "PostMaster" || major.degreeType == "Professional" || major.degreeType == "Doctoral"; });

                }
            },(reason) => {
                    console.error(reason);

                });


        }

        findDegreeType(a, b) {
            return _.map(a, "degreeType").indexOf(b) > -1;
        }

        findAnyGradDegrees() {
            var gradMajors = _.map(this.majors, "degreeType");
            return gradMajors.indexOf("PostBachelor") > -1 ? true : gradMajors.indexOf("Master") > -1 ? true : gradMajors.indexOf("PostMaster") > -1 ? true :
                gradMajors.indexOf("Professional") > -1 ? true : gradMajors.indexOf("Doctoral") > -1 ? true : false;
        }

        getCarouselCount() {
            this.Restangular.one(this.institutionId.toString()).one("carousel/count").get()
                .then((result: any) => {
                    if (result.length == 0) {
                        this.photoInstitutionId = "institutions/0";
                        this.carouselCount = ["carousel1", "carousel2", "carousel3", "carousel4", "carousel5"];
                    }
                    else {
                        this.photoInstitutionId = this.institutionId;
                        this.carouselCount = result;
                    }
            },(reason) => {
                    console.log(reason);
                });
        }

        saveCollege = () => {
            sessionStorage.setItem("collegeProfile.command", "save");
            this.common.authentication.authenticate(true).then(() => {
                sessionStorage.removeItem("collegeProfile.command");
                if (!this.isSaved) {
                    var modalInstance = this.$uibModal.open({
                        templateUrl: '/app/common/confirmationModal.html',
                        controller: 'confirmationModal',
                        resolve: {
                            data: {
                                title: "Save College",
                                content: "Are you sure you want to add " + this.institution.name + " to your list of Saved Colleges?"
                            }
                        }
                    });
                    modalInstance.result.then((result) => {
                        if (result) {
                            this.saveSchoolService.saveSchoolAfterLogin(this.institution.crossRoadsOrganizationId, true);
                            this.Restangular.one("collegePlanning").post(this.institution.crossRoadsOrganizationId)
                                .then((result: any) => {
                                    this.isSaved = true;
                                    this.logSuccess("Saved successfully to your Saved Colleges", "Saved successfully to your Saved Colleges", true);
                                }, (reason) => {
                                    this.logError(reason, reason, true);
                                });
                        }
                    });
                }
                else {
                    var modalInstance = this.$uibModal.open({
                        templateUrl: '/app/common/confirmationModal.html',
                        controller: 'confirmationModal',
                        resolve: {
                            data: {
                                title: "Remove Saved College",
                                content: `Are you sure you wish to remove ${this.institution.name} from your saved colleges?`
                            }
                        }
                    });
                    modalInstance.result.then((val: boolean) => {
                        if (val) {
                            this.Restangular.all("collegePlanning/deletesavedcollege").post({ id: this.institution.id, organizationId: this.institution.crossRoadsOrganizationId }).then((results) => {
                                console.log(results);
                                this.isSaved = false;
                                //this.logSuccess("Your saved college changes have been saved", null, true);
                            }, (reason) => {
                                console.error(reason);
                            });
                        }
                    });
                }
            });
            
            
            
        }

        isCollegeSaved = () => {
            this.Restangular.one("collegePlanning/issaved", this.institution.crossRoadsOrganizationId).get()
                .then((result: boolean) => {
                this.isSaved = result;

                if (this.isSaved == true && this.saveSchoolService.saveSchoolAfterLogin(this.institution.crossRoadsOrganizationId)) {
                    this.logSuccess("Saved successfully to your Saved Colleges", "Saved successfully to your Saved Colleges", true);
                    this.saveSchoolService.clear();
                } else if (!this.isSaved == true && this.saveSchoolService.saveSchoolAfterLogin(this.institution.crossRoadsOrganizationId)) {
                    this.saveCollege();
                }
            },(reason) => {
                this.logError(reason, reason, true);
                });

        }

        getRecruited = () => {
            sessionStorage.setItem("collegeProfile.command", "getrecruited");
            this.common.authentication.authenticate(true).then(() => {
                sessionStorage.removeItem("collegeProfile.command");
                var modalInstance = this.$uibModal.open({
                    templateUrl: '/app/common/confirmationModal.html',
                    controller: 'confirmationModal',
                    resolve: {
                        data: {
                            title: "Get Recruited",
                            content: "Are you sure you want to add " + this.institution.name + " to your College Recruiter so they can contact you?"
                        }
                    }
                });

                modalInstance.result.then((result) => {
                    if (result) {
                        this.getRecruitedService.getRecruitedAfterLogin(this.institution.crossRoadsOrganizationId, true);
                        this.Restangular.all("prospect/addRecruiter").post({ applicationDefinitionId: this.institution.recruiterApplicationId, source: "College Recruiter" })
                            .then((result: any) => {
                                this.logSuccess("Successfully saved to college recruiter", "Successfully saved to college recruiter", true);
                                this.isRecruited = true;
                                this.getRecruitedService.clear();
                                this.getRecruitedService.orginizationId = "";
                            }, (reason) => {
                                this.logError("There was an error saving the request.", reason, true);
                            });
                    }
                })
            });
            

            
        };

        isProspectSubmitted = () => {
            this.Restangular.one("prospect", this.institution.recruiterApplicationId).one("isrecruited").get()
                .then((result) => {
                if (result) {
                    this.isRecruited = result;
                    if (this.isRecruited == true && this.getRecruitedService.getRecruitedAfterLogin(this.institution.crossRoadsOrganizationId)) {
                        this.logSuccess("Successfully saved to college recruiter", "Successfully saved to college recruiter", true);
                        this.getRecruitedService.clear();
                    }
                } else {
                    if (this.isRecruited == false && this.getRecruitedService.getRecruitedAfterLogin(this.institution.crossRoadsOrganizationId)) {
                        this.getRecruited();
                    }
                }

                   

                                
            },(reason) => {
                    console.log(reason);
            });
        };

        nextSlide = () => {
            if (this.activeSlide < this.slides.length - 1) {
                this.activeSlide += 1;
            }
            
        };

        prevSlide = () => {
            if (this.activeSlide > 0) {
                this.activeSlide -= 1;
            }
            
        };

        updateAppInsights = () => {
            appInsights.trackPageView(`Cfnc: Campus Profile - ${this.institution.name} - ${this.templateUrl}`, this.$location.url(), {
                InstitutionId: this.institution.id.toString(),
                Name: this.institution.name
            });
        };

        getNavUrl(newPath) {
            window.history.pushState({}, '', `/campus-profile/${this.$routeParams.institutionName}/${newPath}`);
            
        }
    }

    angular.module("app").controller(CampusProfile.controllerId, CampusProfile);




}
